var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1441_3054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.03432 19.1582C1.98356 19.314 1.97856 19.4812 2.0199 19.6398C2.06124 19.7984 2.1472 19.9418 2.26757 20.0531C2.38794 20.1643 2.53769 20.2387 2.69906 20.2675C2.86043 20.2962 3.02666 20.2781 3.17804 20.2152L21.8625 12.4766C22.0199 12.4112 22.1542 12.3004 22.2483 12.1583C22.3424 12.0161 22.392 11.8492 22.3907 11.6787C22.3895 11.5083 22.3374 11.342 22.2412 11.2013C22.145 11.0606 22.009 10.9518 21.8506 10.8887L3.05422 3.43057C2.90192 3.36998 2.73544 3.35432 2.57452 3.38545C2.41359 3.41659 2.26497 3.49322 2.14627 3.60625C2.02756 3.71928 1.94376 3.86397 1.90478 4.02318C1.86581 4.18239 1.8733 4.34943 1.92637 4.50451L4.33049 11.5417C4.39133 11.7177 4.39318 11.9088 4.33576 12.086L2.03674 19.1582L2.03432 19.1582Z",
    stroke: "#3474E0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12L4.5 13.7321L4.5 10.2679L12 12Z",
    fill: "#3474E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1441_3054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/send_message.c8354b0195105a25a0566acdb1c1d27d.svg";
export { ForwardRef as ReactComponent };